import globalData from './globalData'

export const WP_AJAX_URL = globalData.ajax_url

export const NONCE = globalData.nonce

//TODO: Restrict this API key. le
export const GOOGLE_MAPS_API_KEY = globalData.google_maps_api_key

export const GOOGLE_PLACES_CLIENTSIDE_API_KEY =
  globalData.google_places_clientside_api_key

export const GOOGLE_MAPS_STYLES = globalData.google_maps_styles

export const WP_API_BASE = '/dhsv/v1'

export const isDev = process.env.NODE_ENV === 'development'
